import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authState } from "../atoms/authState";
import { cashMovementsState } from "../atoms/cashMovementsState";
import { checkCashMovementsStatus } from "../services/featureFlagsService";

export const useCashMovementsInit = () => {
  const authValue = useRecoilValue(authState);
  const setCashMovementsState = useSetRecoilState(cashMovementsState);

  useEffect(() => {
    if (!authValue?.user) {
      return;
    }

    const checkStatus = async () => {
      try {
        setCashMovementsState((prev) => ({ ...prev, loading: true }));
        const data = await checkCashMovementsStatus();
        setCashMovementsState({
          enabled: data.enabled,
          canConfigure: data.canConfigure,
          loading: false,
          error: null,
        });
      } catch (err) {
        setCashMovementsState({
          enabled: false,
          canConfigure: false,
          loading: false,
          error: err.message,
        });
      }
    };

    checkStatus();
  }, [authValue?.user, setCashMovementsState]);
};
